<template>
  <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M14.2988 3.60753C14.6132 2.64017 15.9817 2.64017 16.296 3.60754L18.362 9.96595C18.5026 10.3986 18.9057 10.6915 19.3606 10.6915H26.0462C27.0634 10.6915 27.4863 11.993 26.6634 12.5909L21.2546 16.5206C20.8866 16.788 20.7326 17.2619 20.8732 17.6945L22.9391 24.053C23.2535 25.0203 22.1463 25.8247 21.3234 25.2269L15.9146 21.2972C15.5466 21.0298 15.0483 21.0298 14.6803 21.2972L9.27147 25.2269C8.44858 25.8247 7.3414 25.0203 7.65571 24.053L9.72169 17.6945C9.86225 17.2619 9.70827 16.788 9.34026 16.5206L3.93146 12.5909C3.10858 11.993 3.53149 10.6915 4.54863 10.6915H11.2343C11.6891 10.6915 12.0923 10.3986 12.2329 9.96595L14.2988 3.60753Z" :fill="color"/>
  </svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#EB883B',
    },
  },
};
</script>
